import React, { Component } from 'react'
import { Grid } from '@material-ui/core'
import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import MainPlayer from '../components/player/MainPlayer'
import SectionContainer from '../components/sections/SectionContainer'
import ApiClient from '../services/ApiClient'
import ConfigData from '../config/ConfigData'
import {maxWidthForSection, onVideoClick} from '../services/Utils'


class VideoHubApp extends Component {
  constructor(props) {
    super(props)

    this.mainPlayer = React.createRef();

    this.renderSections = this.renderSections.bind(this)
    this.state = {
      mainPlaylist: [],
      sections: []
    }
  }

  componentDidMount() {
    this.loadVoltaxViewScript()
    ApiClient.getPlaylist(ConfigData.mainPlayer.playlistID).then(playlist => {
      this.setState({
        mainPlaylist: playlist.data
      })
    })
    const promises = [
      ...ConfigData.sections.map(section => ApiClient.getPlaylist(section.id))
    ]
    Promise.all(promises).then(playlists => {
      const sections = ConfigData.sections.map((section, index) => {
        const playlist = playlists[index].data.slice(0, 25)
        return {...section, playlist}
      })
      this.setState({
        sections
      })
    }).catch(error => {
      console.log(error);
    })
  }

  loadVoltaxViewScript() {
    const script = document.createElement("script");
    script.src = "https://www.oo-syringe.com/prod/view/index.js";
    script.async = true;

    script.addEventListener("load", () => {
      const voltaxView = window.voltax.view.init(ConfigData.voltaxView.playerConfig, ConfigData.voltaxView.viewConfig);
      this.setState({ voltaxView })
    }, false);

    this.container.appendChild(script)
  }

  renderSections() {
    return (
      <Grid container style={{maxWidth: maxWidthForSection}}>
        {this.state.sections.map((section,index) => {
          const sectionNumber = index % 3
          const type = sectionNumber === 0 ? 'carousel' :(sectionNumber === 1 ? 'horizontalList' : 'threeItems' )
          return <SectionContainer
            key={index}
            name={section.name}
            playlist={section.playlist}
            type={type}
            onVideoClicked={(videoIndex) => {
              this.mainPlayer.current.pause()
              onVideoClick(section.id, section.playlist[videoIndex], sectionNumber, this.state.voltaxView)
            }}
          />
        })}
      </Grid>
    )
  }

  render() {
    return (
      <Grid container direction='column' alignItems='center' className={`root`}>
        <Grid item container ref={el => (this.container = el)} />
        <Header
          targetUrl={ConfigData.header.targetUrl}
          brandLogo={ConfigData.header.brandLogo}
          navigationCategories={ConfigData.header.navigationCategories}
        />
        <MainPlayer
          ref={this.mainPlayer}
          playerId={ConfigData.mainPlayer.playerID}
          playlistId={ConfigData.mainPlayer.playlistID}
          playlist={this.state.mainPlaylist}
        />
        {this.renderSections()}
        <Footer
          links={ConfigData.footer.links}
          socialLinks={ConfigData.footer.socialLinks}
        />
      </Grid>
    )
  }
}

export default VideoHubApp
